export default {
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
};
